// Static data for each product line detail page.
// Used by ProductLineDetail route. Content crafted from the brand book + market positioning.
export const LINES = {
    fruit: {
        id: "fruit",
        name: "FRUIT",
        tagline: "A linha base",
        headline: "Polpa de fruta pura, no ponto certo.",
        description:
            "A nossa linha base: 8 sabores de polpa de fruta congelada, em doses individuais ou bolsas a granel. Fruta colhida no pico de maturação e conservada a -18 °C para garantir sabor e nutrientes todo o ano.",
        heroImage: "/brand/pack-morango-real.png",
        color: "#F99700",
        accentClass: "text-brand-orange",
        bgClass: "bg-brand-orange-soft",
        ringClass: "ring-brand-orange/20",
        flavors: [
            "Abacaxi",
            "Morango",
            "Manga",
            "Tutti Fruti",
            "Maracujá",
            "Frutos Vermelhos",
            "Limonada",
            "Detox",
        ],
        ingredients: ["Polpa de fruta 100%", "Sem açúcar adicionado", "Sem conservantes", "Sem corantes"],
        nutrition: [
            { label: "Calorias", value: "45 kcal / 100 g" },
            { label: "Açúcares", value: "naturais da fruta" },
            { label: "Fibra", value: "2,8 g / 100 g" },
            { label: "Proteína", value: "0,8 g / 100 g" },
        ],
        formats: [
            { type: "Doses individuais", detail: "100 g · 1 copo", best: "Cafés, restaurantes" },
            { type: "Bolsa 1 kg", detail: "≈ 10 copos", best: "Pastelarias, padarias" },
            { type: "Bolsa 5 kg", detail: "≈ 50 copos", best: "Ginásios, eventos" },
        ],
        useCases: [
            {
                title: "Sumo natural",
                text: "100 g polpa + 200 ml água + gelo. Pronto em 30 s.",
            },
            {
                title: "Smoothie",
                text: "Adiciona leite ou iogurte para cremosidade extra.",
            },
            {
                title: "Cocktails & Mocktails",
                text: "Base perfeita para bebidas de autor na tua carta.",
            },
        ],
        bestFor: ["Cafés", "Restaurantes", "Pastelarias", "Padarias", "Hotelaria"],
    },
    detox: {
        id: "detox",
        name: "DETOX",
        tagline: "Vegetais + fruta verde",
        headline: "Funcional. Limpa. Naturalmente verde.",
        description:
            "Mistura cuidadosamente calibrada de frutas e vegetais de folha verde. Rica em clorofila, antioxidantes e fibra. Ideal para clientes conscientes que procuram bem-estar e leveza.",
        heroImage: "/brand/line-detox.jpg",
        color: "#2D9E3A",
        accentClass: "text-brand-green",
        bgClass: "bg-brand-green-soft",
        ringClass: "ring-brand-green/20",
        flavors: [
            "Detox Clássico (maçã + espinafre + pepino)",
            "Detox Citrus (lima + gengibre + hortelã)",
            "Detox Energy (maçã verde + matcha)",
            "Detox Tropical (abacaxi + couve + hortelã)",
        ],
        ingredients: [
            "Maçã, pepino, espinafre, couve",
            "Gengibre, hortelã, limão",
            "Sem açúcar adicionado",
            "Rico em clorofila e vitamina C",
        ],
        nutrition: [
            { label: "Calorias", value: "38 kcal / 100 g" },
            { label: "Fibra", value: "3,2 g / 100 g" },
            { label: "Vitamina C", value: "45 % DDR" },
            { label: "Clorofila", value: "alta concentração" },
        ],
        formats: [
            { type: "Doses individuais", detail: "100 g · 1 copo", best: "SPAs, clínicas" },
            { type: "Bolsa 1 kg", detail: "≈ 10 copos", best: "Ginásios, yoga" },
            { type: "Bolsa 5 kg", detail: "≈ 50 copos", best: "Hotéis, retiros" },
        ],
        useCases: [
            {
                title: "Shot de manhã",
                text: "50 g polpa + 100 ml água — energia limpa para começar.",
            },
            {
                title: "Green smoothie",
                text: "Adiciona maçã + iogurte grego. Detox com cremosidade.",
            },
            {
                title: "Pós-yoga / pilates",
                text: "Recarga electrolítica sem açúcar refinado.",
            },
        ],
        bestFor: ["Ginásios", "SPAs", "Hotelaria", "Clubes de Desporto", "Retiros"],
    },
    protein: {
        id: "protein",
        name: "PROTEIN",
        tagline: "Fruta + proteína",
        headline: "Recuperação que sabe mesmo a fruta.",
        description:
            "Polpa de fruta enriquecida com 25 g de proteína vegetal por dose. Pronto a servir como recuperador pós-treino — sabor incrível, textura cremosa, zero artificial.",
        heroImage: "https://images.unsplash.com/photo-1623428454614-abaf00244e52?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
        color: "#D63654",
        accentClass: "text-[#D63654]",
        bgClass: "bg-brand-pink",
        ringClass: "ring-[#D63654]/20",
        flavors: [
            "Protein Morango",
            "Protein Frutos Vermelhos",
            "Protein Banana",
            "Protein Cacau & Frutos Vermelhos",
        ],
        ingredients: [
            "Polpa de fruta + proteína de ervilha e arroz",
            "Sem lactose, sem glúten",
            "Sem açúcar adicionado",
            "Stévia natural",
        ],
        nutrition: [
            { label: "Proteína", value: "25 g / dose" },
            { label: "Calorias", value: "180 kcal / dose" },
            { label: "Açúcares", value: "naturais da fruta" },
            { label: "BCAAs", value: "5,2 g / dose" },
        ],
        formats: [
            { type: "Doses individuais", detail: "200 g · 1 shake", best: "Ginásios, clubes" },
            { type: "Bolsa 1 kg", detail: "≈ 5 doses", best: "Studios de treino" },
            { type: "Bolsa 5 kg", detail: "≈ 25 doses", best: "Boxes, crossfit, hotéis" },
        ],
        useCases: [
            {
                title: "Shake pós-treino",
                text: "200 g polpa + 250 ml água ou leite vegetal. 30 s no liquidificador.",
                },
            {
                title: "Pré-treino leve",
                text: "Energia e amino-ácidos naturais, sem carga digestiva.",
            },
            {
                title: "Pequeno-almoço",
                text: "Com aveia + sementes — refeição completa em 5 min.",
            },
        ],
        bestFor: ["Ginásios", "Clubes de Desporto", "Boxes & CrossFit", "Studios", "Atletas"],
    },
    tea: {
        id: "tea",
        name: "TEA",
        tagline: "Infusões frias",
        headline: "O chá gelado que finalmente sabe a algo.",
        description:
            "Chás frios combinados com polpa de fruta. A alternativa natural e premium aos refrigerantes — baixo em cafeína, zero artificial, incrivelmente refrescante.",
        heroImage: "https://images.unsplash.com/photo-1556679343-c7306c1976bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
        color: "#C89800",
        accentClass: "text-[#C89800]",
        bgClass: "bg-brand-yellow",
        ringClass: "ring-[#C89800]/20",
        flavors: [
            "Chá Verde + Limão",
            "Chá Preto + Pêssego",
            "Hibisco + Frutos Vermelhos",
            "Rooibos + Manga",
            "Matcha + Maracujá",
        ],
        ingredients: [
            "Chá (verde, preto, rooibos, hibisco, matcha)",
            "Polpa de fruta natural",
            "Sem açúcar adicionado",
            "Baixo em cafeína",
        ],
        nutrition: [
            { label: "Calorias", value: "25 kcal / 100 g" },
            { label: "Cafeína", value: "15–30 mg / dose" },
            { label: "Antioxidantes", value: "polifenóis e catequinas" },
            { label: "Açúcares", value: "naturais da fruta" },
        ],
        formats: [
            { type: "Doses individuais", detail: "100 g · 1 copo (300 ml)", best: "Cafés, esplanadas" },
            { type: "Bolsa 1 kg", detail: "≈ 10 copos", best: "Restaurantes, hotéis" },
            { type: "Bolsa 5 kg", detail: "≈ 50 copos", best: "Eventos, catering" },
        ],
        useCases: [
            {
                title: "Chá gelado na esplanada",
                text: "Alternativa premium ao ice tea de pacote. Cliente nota a diferença.",
            },
            {
                title: "Pausa da tarde",
                text: "Energia suave sem o pico do café. Ideal entre refeições.",
            },
            {
                title: "Bar de piscina / eventos",
                text: "Serve-se frio, sem necessidade de infusão. Prático e rentável.",
            },
        ],
        bestFor: ["Cafés", "Restaurantes", "Hotelaria", "Esplanadas", "Eventos"],
    },
};

export const LINE_IDS = ["fruit", "detox", "protein", "tea"];
